export enum InstancesTableTestId {
  InstanceName = 'InstanceTableTestIdInstanceName',
  Table = 'InstancesTableTestIdTable',
}
